import React from 'react'
import HeroBgAnimation from '../HeroBgAnimation'
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle, ResumeButton } from './HeroStyle'
import HeroImg from '../../images/HeroImg.jpg'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import { FaGithub, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa6";
import { SiLeetcode, SiCodingninjas } from "react-icons/si";
import "../HeroSection/Hero.css"

const HeroSection = () => {




    return (
        <div id="about">
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <Title>Hi, I am <br /> {Bio.name}</Title>
                        <TextLoop>
                            I am a
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle>{Bio.description}</SubTitle>


                        <section className='media-icons'>
                            <div className='linkedinInIcons'>
                                <a href='https://www.linkedin.com/in/himanshu82/' target='_blank'>
                                    <FaLinkedinIn />
                                </a>
                            </div>
                            <div className='githubIcons'>
                                <a href='https://github.com/himanshu9997' target='_blank'>
                                    <FaGithub />
                                </a>
                            </div>
                            <div className='leetcode'>
                                <a href='https://leetcode.com/u/Himanshu9997/' target='_blank'>
                                    <SiLeetcode />
                                </a>
                            </div>
                            <div className='Codingninjas'>
                                <a href='https://www.naukri.com/code360/profile/HimanshuCode' target='_blank'>
                                    <SiCodingninjas />
                                </a>
                            </div>
                            <div className='InstagramIcons'>
                                <a href='https://www.instagram.com/2663himanshu/?hl=en' target='_blank'>
                                    <FaInstagram />
                                </a>
                            </div>
                            <div className='twitterIcons'>
                                <a href='https://twitter.com/Himanshuch58449' target='_blank'>
                                    <FaTwitter />
                                </a>
                            </div>


                        </section>


                        <ResumeButton href="https://drive.google.com/file/d/17CMJ3qNn3g-VmBBM9j5ezNdK0Uex10Ew/view?usp=drive_link" target='display'>Resume</ResumeButton>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">

                        <Img src={HeroImg} alt="hero-image" />
                    </HeroRightContainer>
                </HeroInnerContainer>

            </HeroContainer>
        </div>
    )
}

export default HeroSection